import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f410222c")

_pushScopeId("data-v-f410222c")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Get unlimited access on all your devices by choosing an auto-renewing subscription plan ")
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("(7 day free trial, Billed monthly)")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("You are currently Subscribed Monthly")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Start Now")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Why not switch to an Annual Subscription to and save 25%?")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = { key: 3 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("You are currently Subscribed Annually")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Start Now")
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Manage your Subscription")
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Restore Purchases")
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Terms of Service")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Privacy Policy")
const _hoisted_34 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_router_link = _resolveComponent("ion-router-link")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_back_button, {
                    icon: "chevron-back",
                    text: "",
                    color: "medium",
                    "default-href": "/settings"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_ion_card, { color: "light" }, {
            default: _withId(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withId(() => [
                      _createTextVNode("Join " + _toDisplayString(_ctx.client.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, { class: "text-center" }, {
                default: _withId(() => [
                  _hoisted_1,
                  _createVNode(_component_ion_text, null, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _hoisted_3,
                  _hoisted_4,
                  (!_ctx.subsloading)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        (!_ctx.sub2)
                          ? (_openBlock(), _createBlock("div", _hoisted_6, [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.purchase('sub002'))),
                                color: "success",
                                size: "block"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.p1.price) + " / month.", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_text, { class: "text-sm" }, {
                                default: _withId(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }),
                              _hoisted_8,
                              _hoisted_9
                            ]))
                          : (!_ctx.sub3)
                            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                _createVNode(_component_ion_text, null, {
                                  default: _withId(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  color: "primary",
                                  href: "/classes",
                                  fill: "solid",
                                  size: "block"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_12
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_text, { class: "text-sm" }, {
                                  default: _withId(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                }),
                                _hoisted_14,
                                _hoisted_15
                              ]))
                            : _createCommentVNode("", true),
                        (!_ctx.sub3)
                          ? (_openBlock(), _createBlock("div", _hoisted_16, [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.purchase('sub003'))),
                                color: "success",
                                size: "block"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.p2.price) + " / year.", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_text, { class: "text-sm" }, {
                                default: _withId(() => [
                                  _createTextVNode("(7 day free trial, 12 months at " + _toDisplayString(_ctx.savings) + "/mo save 25%)", 1)
                                ]),
                                _: 1
                              }),
                              _hoisted_17,
                              _hoisted_18
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_19, [
                              _createVNode(_component_ion_text, null, {
                                default: _withId(() => [
                                  _hoisted_20
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                color: "primary",
                                href: "/classes",
                                fill: "solid",
                                size: "block"
                              }, {
                                default: _withId(() => [
                                  _hoisted_21
                                ]),
                                _: 1
                              }),
                              _hoisted_22,
                              _hoisted_23
                            ])),
                        (!_ctx.sub2 || !_ctx.sub3)
                          ? (_openBlock(), _createBlock(_component_ion_text, {
                              key: 4,
                              class: "text-sm"
                            }, {
                              default: _withId(() => [
                                _createTextVNode("Payment will be charged to your " + _toDisplayString(_ctx.storeName) + " account at the confirmation of purchase. Subscription automatically renews unless it is canceled at least 24 hours before the end of the current period. Your account will be charged for renewal within 24 hours prior to the end of the current period. You can manage and cancel your subscriptions by going to your account settings on the " + _toDisplayString(_ctx.storeName) + " Store after purchase.", 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sub2 || _ctx.sub3)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 5,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ManageSub())),
                              color: "secondary",
                              size: "block"
                            }, {
                              default: _withId(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _hoisted_25,
                        _hoisted_26,
                        _hoisted_27,
                        _hoisted_28,
                        _createVNode(_component_ion_button, {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.restorePurchases())),
                          size: "small",
                          fill: "outline"
                        }, {
                          default: _withId(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }),
                        _hoisted_30,
                        _createVNode(_component_ion_text, { class: "text-sm" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_router_link, null, {
                              default: _withId(() => [
                                _hoisted_31
                              ]),
                              _: 1
                            }),
                            _hoisted_32,
                            _createVNode(_component_ion_router_link, null, {
                              default: _withId(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_34, "Fetching Subscriptions..."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withId(() => [
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_col)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})